import React, { useState, useEffect } from "react";
import { Layout, Menu, Affix, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import LogoOriginal from "../img/logo.png";

const { Header } = Layout;

export const NavComponent = ({ contactoBgColor }) => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);

      if (window.innerWidth > 1024) {
        setDrawerOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showDrawer = () => {
    setDrawerOpen(true);
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
  };

  const handleScroll = (id) => {
    const sectionId = isMobile && id === "productos" ? "productos-telefonos" : id;
  
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    closeDrawer(); 
  };
  

  const menuItems = [
    {
      key: "1",
      label: <a onClick={() => handleScroll("quienesSomos")}>Nosotros</a>,
    },
    { key: "2", label: <a href="/desarrollo">Desarrollo</a> },
    { key: "3", label: <a href="/infraestructura">Infraestructura</a> },
    {
      key: "4",
      label: <a onClick={() => handleScroll("productos")}>Productos</a>,
    },
    {
      key: "5",
      label: <a onClick={() => handleScroll("enviarCV")}>Enviá tu CV</a>,
    },
    {
      key: "6",
      label: <a onClick={() => handleScroll("contacto")}>Contacto</a>,
    },
  ];

  return (
    <Affix>
      <Header className="navbar">
        <div className="logo">
          <img src={LogoOriginal} alt="Logo" />
        </div>
        {/* Menú para escritorio */}
        {!isMobile && (
          <div className="menu-desktop">
            <Menu mode="horizontal" items={menuItems} />
          </div>
        )}
        {/* Menú para teléfono */}
        {isMobile && (
          <div className="menu-mobile">
            <Button
              type="text"
              icon={<MenuOutlined className="icono-menu-mobile" />}
              onClick={showDrawer}
              aria-label="Abrir menú de navegación"
            />
          </div>
        )}
        {/* Drawer para teléfono */}
        <Drawer placement="right" onClose={closeDrawer} open={isDrawerOpen}>
          <Menu
            mode="vertical"
            items={menuItems}
            onClick={closeDrawer}
          />
        </Drawer>
      </Header>
    </Affix>
  );
};
